__turbopack_context__.v({
  "animate": "FooterShreds-module-scss-module__XweU3a__animate",
  "fade-in": "FooterShreds-module-scss-module__XweU3a__fade-in",
  "inner": "FooterShreds-module-scss-module__XweU3a__inner",
  "root": "FooterShreds-module-scss-module__XweU3a__root",
  "rotate": "FooterShreds-module-scss-module__XweU3a__rotate",
  "shred": "FooterShreds-module-scss-module__XweU3a__shred",
  "shredA": "FooterShreds-module-scss-module__XweU3a__shredA",
  "shredB": "FooterShreds-module-scss-module__XweU3a__shredB",
  "shredC": "FooterShreds-module-scss-module__XweU3a__shredC",
  "shredD": "FooterShreds-module-scss-module__XweU3a__shredD",
  "shredE": "FooterShreds-module-scss-module__XweU3a__shredE",
  "shredF": "FooterShreds-module-scss-module__XweU3a__shredF",
  "shredG": "FooterShreds-module-scss-module__XweU3a__shredG",
  "shredH": "FooterShreds-module-scss-module__XweU3a__shredH",
  "shredI": "FooterShreds-module-scss-module__XweU3a__shredI",
  "shredImage": "FooterShreds-module-scss-module__XweU3a__shredImage",
  "shredJ": "FooterShreds-module-scss-module__XweU3a__shredJ",
  "shredK": "FooterShreds-module-scss-module__XweU3a__shredK",
  "shredL": "FooterShreds-module-scss-module__XweU3a__shredL",
  "shredM": "FooterShreds-module-scss-module__XweU3a__shredM",
  "shredN": "FooterShreds-module-scss-module__XweU3a__shredN",
  "shredO": "FooterShreds-module-scss-module__XweU3a__shredO",
  "toss": "FooterShreds-module-scss-module__XweU3a__toss",
});
